import { render, staticRenderFns } from "./BulkIssueActionFooter.vue?vue&type=template&id=0c650efe&scoped=true"
import script from "./BulkIssueActionFooter.vue?vue&type=script&lang=js"
export * from "./BulkIssueActionFooter.vue?vue&type=script&lang=js"
import style0 from "./BulkIssueActionFooter.vue?vue&type=style&index=0&id=0c650efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c650efe",
  null
  
)

export default component.exports